import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const Privacy = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // change to 'auto' if you want instant
      });
    }, []);
  return (
    <MainLayout
      title="Privacy Policy | Fundo"
      description="Learn how Fundo collects, uses, and protects your data."
    >
      {/* HEADER */}
      <section className="max-w-3xl">
        <p className="text-xs uppercase tracking-[0.35em] text-[#8b5e3c]">Privacy</p>

        <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f] sm:text-6xl">
          Your data, handled with intention.
        </h1>

        <p className="mt-6 text-lg leading-8 text-[#4f4034]">
          This Privacy Policy explains how Fundo collects, uses, and protects your information when
          you use our platform.
        </p>

        <p className="mt-4 text-sm text-[#8b5e3c]">Last updated: April 2026</p>
      </section>

      {/* CONTENT */}
      <section className="mt-20 max-w-3xl space-y-14">
        {/* INFO WE COLLECT */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">1. Information We Collect</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            We collect information necessary to provide and improve Fundo services. This includes:
          </p>

          <ul className="mt-4 space-y-3 text-sm text-[#4f4034]">
            <li>• Account information (name, phone number, email)</li>
            <li>• Farm data (expenses, harvests, sales, farm activity)</li>
            <li>• Transaction data (marketplace activity, payments)</li>
            <li>• Device and usage data</li>
            <li>• Communications via SMS, USSD, or app interactions</li>
          </ul>
        </div>

        {/* HOW WE USE DATA */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">2. How We Use Your Information</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo uses your data to operate, improve, and personalize the platform. This includes:
          </p>

          <ul className="mt-4 space-y-3 text-sm text-[#4f4034]">
            <li>• Providing farm insights and analytics</li>
            <li>• Enabling marketplace transactions and auctions</li>
            <li>• Supporting virtual farming participation</li>
            <li>• Facilitating financial services (loans, savings, insurance)</li>
            <li>• Improving system performance and user experience</li>
          </ul>
        </div>

        {/* DATA SHARING */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">3. Data Sharing</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            We do not sell your personal data. We may share information with trusted partners where
            necessary to deliver services:
          </p>

          <ul className="mt-4 space-y-3 text-sm text-[#4f4034]">
            <li>• Financial institutions (for loans and payments)</li>
            <li>• Buyers and sellers within the marketplace</li>
            <li>• Service providers supporting platform infrastructure</li>
          </ul>
        </div>

        {/* ACCESSIBILITY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">4. Accessibility Across Channels</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            Fundo operates across mobile apps, SMS, and USSD. Information shared through these
            channels is processed securely, but standard telecom limitations may apply.
          </p>
        </div>

        {/* DATA SECURITY */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">5. Data Security</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            We implement technical and organizational safeguards to protect your information.
            However, no system is completely secure, and we encourage users to protect their account
            credentials.
          </p>
        </div>

        {/* USER RIGHTS */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">6. Your Rights</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            You have the right to access, update, or request deletion of your data. You may also opt
            out of certain communications at any time.
          </p>
        </div>

        {/* RETENTION */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">7. Data Retention</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            We retain data only as long as necessary to provide services and comply with legal
            obligations.
          </p>
        </div>

        {/* UPDATES */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">8. Policy Updates</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            This policy may be updated periodically. Continued use of Fundo indicates acceptance of
            any updates.
          </p>
        </div>

        {/* CONTACT */}
        <div>
          <h2 className="font-serif text-2xl text-[#1b140f]">9. Contact</h2>

          <p className="mt-4 text-[#4f4034] leading-8">
            For questions about this Privacy Policy, contact us at:
          </p>

          <p className="mt-4 text-sm text-[#8b5e3c]">fundofarmer@gmail.com</p>
        </div>
      </section>
    </MainLayout>
  );
};
